/**
 * Checks if an IPM account integration is enabled within the provided list of integrations.
 *
 * @param {Array} integrations - An array of integration objects.
 * @returns {boolean} - Returns `true` if an IPM integration with `enable_integration_read`
 *                      set to `true` is found, otherwise returns `false`.
 *
 * Usage:
 * - Each integration object should support the Immutable.js `get` and `getIn` methods.
 * - The function checks for:
 *   1. `type` being "ipm".
 *   2. The "enable_integration_read" flag being set to `true` within the "settings".
 */
export const hasIPMAccountIntegration = (integrations) => {
  return integrations.some((item) => {
    return (
      item.get("type") === "ipm" &&
      item.getIn(["settings", "enable_integration_read"]) === true
    );
  });
};

export const INTEGRATION_ERROR_TYPE = (accountID) => ({
  NON_NZ_TENANT: {
    title: "Xero Settings",
    subtitle: "Non NZ Xero Organisation Selected",
    message:
      "Only NZ Xero organisations can be selected. Please sign in and select an NZ Xero organisation.",
    buttonSettings: [
      {
        text: "Reconnect to Xero",
        button: "GreenPrimaryButton",
        url: `/api/account/${accountID}/xero/login`,
      },
    ],
  },
  EXPIRED_XERO_TOKEN: {
    title: "Xero Settings",
    subtitle: "Integration Expired",
    message:
      "Integration with Xero has expired and need to be reconnected in order to continue.",
    buttonSettings: [
      {
        text: "Reconnect to Xero",
        button: "GreenPrimaryButton",
        url: `/api/account/${accountID}/xero/login`,
      },
    ],
  },
  XERO_DISCONNECTED: {
    title: "Xero Settings",
    subtitle: "Integration Disconnected",
    message:
      "Integration with Xero has been removed and needs to be reconnected in order to continue.\n\nIf you disconnected the integration yourslef in Xero, Turn Off will fully remove Xero from this Paylab. You can still reconnect in the future.",
    buttonSettings: [
      {
        text: "Reconnect to Xero",
        button: "GreenPrimaryButton",
        url: `/api/account/${accountID}/xero/login`,
      },
      {
        text: "Turn Off",
        button: "GreenSecondaryButton",
        disconnect: true,
      },
    ],
  },
  DEFAULT_XERO_ERROR: {
    title: "Xero Settings",
    subtitle: "Integration Error",
    message:
      "There was an error while trying to retrieve your account details. Please try again later or you can try disconnecting Xero and reconnecting it to PayLab.\n\nNote: You may need to disconnect PayLab from inside Xero",
    buttonSettings: [
      {
        button: "XeroDisconnectButton",
        disconnect: true,
      },
    ],
  },
});
